import type { MessageClass } from '@cotera/sdk/core';

/**
 * Check if any tool in the messages needs approval.
 */
export function hasToolNeedingApproval(messages: MessageClass[]): boolean {
  for (const message of messages) {
    if (!message.isAssistantMessage()) {
      continue;
    }

    for (const part of message.parts) {
      if (!part.isToolPart()) {
        continue;
      }

      if (part.approvalStatus?.() === 'required') {
        return true;
      }
    }
  }

  return false;
}

/**
 * Count tools needing approval.
 */
export function getPendingApprovalCount(messages: MessageClass[]): number {
  let count = 0;

  for (const message of messages) {
    if (!message.isAssistantMessage()) {
      continue;
    }

    for (const part of message.parts) {
      if (!part.isToolPart()) {
        continue;
      }

      if (part.approvalStatus?.() === 'required') {
        count++;
      }
    }
  }

  return count;
}
